<template>
  <main-layout wide>
    <base-card
      ref="catalog"
      medium
    >
      <div :class="showFilter ? 'grid' : '' ">
        <catalog-filter-container style="max-height: 100%;" />
        <catalog-product-list-container
          :selectable="false"
          show-filter-button
          style="margin-top: 10px; display: flex; flex-direction: column;"
        />
      </div>
    </base-card>
  </main-layout>
</template>

<script>
import CatalogProductListContainer from '@/components/Widgets/Catalog/CatalogProductListContainer';
import CatalogFilterContainer from '@/components/Widgets/Catalog/CatalogFilterContainer';
import { EventBus } from '@/event-bus';

export default {
  name: 'CatalogList',
  components: {
    CatalogProductListContainer,
    CatalogFilterContainer,
  },
  data() {
    return {
      ref: 'catalog',
      showFilter: '',
    };
  },
  created() {
    EventBus.$on('showFilter', (val) => {
      this.showFilter = val;
    });
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-gap: 0;
  grid-template-columns: 1fr;
  max-height: 100%;

  @media (min-width: map-get($breakpoints,'lg')) {
    grid-template-columns: 200px 1fr;
    grid-gap: 28px;
  }
}
</style>
